import { render } from "./BlocksList.vue?vue&type=template&id=2ef3bc92"
import script from "./BlocksList.vue?vue&type=script&lang=js"
export * from "./BlocksList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__